/** SAIA-Lizenzen, die einem Benutzer zugeordnet werden können (Wizard: Benutzer → Lizenz). */

export type PlannedLicense = 'saia_recruiting' | 'saia_sales' | 'saia_bundle';

export const LICENSE_OPTIONS: Array<{
  key: PlannedLicense;
  label: string;
  infoDe: string;
  infoEn: string;
}> = [
  {
    key: 'saia_recruiting',
    label: 'SAIA Recruiting',
    infoDe:
      'Für Active Sourcing: Kandidaten auf LinkedIn finden, per KI qualifizieren und automatisiert ansprechen. Enthält Recruiting-Kampagnen, Kandidaten-Suchen und das Recruiting-Postfach.',
    infoEn:
      'For active sourcing: find candidates on LinkedIn, qualify them with AI and reach out automatically. Includes recruiting campaigns, candidate searches and the recruiting inbox.',
  },
  {
    key: 'saia_sales',
    label: 'SAIA Sales',
    infoDe:
      'Für Social Selling & Lead-Generierung: Zielkunden finden und automatisiert ansprechen. Enthält Sales-Kampagnen, Lead-Listen und das Sales-Postfach.',
    infoEn:
      'For social selling & lead generation: find target customers and reach out automatically. Includes sales campaigns, lead lists and the sales inbox.',
  },
  {
    key: 'saia_bundle',
    label: 'SAIA Kombi (Recruiting + Sales)',
    infoDe:
      'Kombilizenz: alle Funktionen aus SAIA Recruiting UND SAIA Sales in einem Seat — für Benutzer, die sowohl Kandidaten als auch Kunden ansprechen.',
    infoEn:
      'Combined license: everything from SAIA Recruiting AND SAIA Sales in one seat — for users who reach out to both candidates and customers.',
  },
];
